import {postWithAuth} from '@/api'
import {ExportOnlinePaymentsRequestType} from '@/stores/transactions/OnlinePaymentsExportsStore/models'

export const exportOnlinePayments = (params: ExportOnlinePaymentsRequestType) =>
    postWithAuth('/oppapi/v1/ecom/transactions/export', params)
